import countries from 'i18n-iso-countries'
import es from 'i18n-iso-countries/langs/es.json'

countries.registerLocale(es)

/** Valores antiguos (archivos locales .webp) → ISO 3166-1 alpha-2 */
const LEGACY_FLAG_MAP = {
  argentina: 'ar',
  espana: 'es',
  spain: 'es'
}

/**
 * Devuelve el código ISO alpha-2 en minúsculas o '' si no es válido.
 * Acepta códigos ISO o nombres legacy del proyecto anterior.
 */
export function normalizeFlagCode(value) {
  if (value == null || value === '') return ''
  const v = String(value).trim().toLowerCase()
  if (LEGACY_FLAG_MAP[v]) return LEGACY_FLAG_MAP[v]
  if (/^[a-z]{2}$/i.test(v)) return v.toLowerCase()
  return ''
}

/**
 * Lista { code, name } ordenada por nombre en español (para el select).
 */
export function getFlagOptionsSorted() {
  const names = countries.getNames('es', { select: 'official' })
  return Object.entries(names)
    .map(([code, name]) => ({ code: code.toLowerCase(), name }))
    .sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))
}
